// Generated by CoffeeScript 2.7.0
var IntegerMixin;

export default IntegerMixin = {
  computed: {
    valueForCalculation: function() {
      var parsed;
      parsed = parseFloat(this.value);
      if (_.isNaN(parsed)) {
        return {
          type: 'Text',
          value: null
        };
      } else {
        return {
          type: 'Text',
          value: parsed
        };
      }
    }
  },
  methods: {
    userInput: function(event) {
      return this.valueChange(event.target.value);
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      return this.value = entry.value;
    },
    _focus: function() {
      return this.$refs.input.focus();
    }
  }
};
